// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/systemlog/v1/export.proto" (package "c1.api.systemlog.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Struct } from "../../../../google/protobuf/struct";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.systemlog.v1.ExportsSearchServiceSearchRequest
 */
export interface ExportsSearchServiceSearchRequest {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * Search for system log exporters with a case insensitive match on the display name.
     *
     * @generated from protobuf field: string display_name = 4
     */
    displayName: string;
    /**
     * @generated from protobuf field: repeated c1.api.systemlog.v1.ExporterRef refs = 5
     */
    refs: ExporterRef[];
}
/**
 * @generated from protobuf message c1.api.systemlog.v1.ExportsSearchServiceSearchResponse
 */
export interface ExportsSearchServiceSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.systemlog.v1.Exporter list = 1
     */
    list: Exporter[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.systemlog.v1.ExportToDatasource
 */
export interface ExportToDatasource {
    /**
     * @generated from protobuf field: string datasource_id = 1
     */
    datasourceId: string;
    /**
     * @generated from protobuf field: string prefix = 2
     */
    prefix: string;
    /**
     * @generated from protobuf field: c1.api.systemlog.v1.ExportFormat format = 3
     */
    format: ExportFormat;
}
/**
 * The ExportServiceCreateRequest message is used to create a new system log exporter.
 *
 * @generated from protobuf message c1.api.systemlog.v1.ExportServiceCreateRequest
 */
export interface ExportServiceCreateRequest {
    /**
     * The display name of the new policy.
     *
     * @generated from protobuf field: string display_name = 1
     */
    displayName: string;
    /**
     * @generated from protobuf oneof: export_to
     */
    exportTo: {
        oneofKind: "datasource";
        /**
         * @generated from protobuf field: c1.api.systemlog.v1.ExportToDatasource datasource = 100
         */
        datasource: ExportToDatasource;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.systemlog.v1.ExportServiceCreateResponse
 */
export interface ExportServiceCreateResponse {
    /**
     * @generated from protobuf field: c1.api.systemlog.v1.Exporter exporter = 1
     */
    exporter?: Exporter;
}
/**
 * @generated from protobuf message c1.api.systemlog.v1.ExporterRef
 */
export interface ExporterRef {
    /**
     * @generated from protobuf field: string export_id = 1
     */
    exportId: string;
}
/**
 * @generated from protobuf message c1.api.systemlog.v1.Exporter
 */
export interface Exporter {
    /**
     * @generated from protobuf field: string export_id = 1
     */
    exportId: string;
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 5
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.systemlog.v1.ExportState state = 6
     */
    state: ExportState;
    /**
     * we've synchorized this far
     *
     * @generated from protobuf field: string watermark_event_id = 7
     */
    watermarkEventId: string;
    /**
     * @generated from protobuf oneof: export_to
     */
    exportTo: {
        oneofKind: "datasource";
        /**
         * @generated from protobuf field: c1.api.systemlog.v1.ExportToDatasource datasource = 100
         */
        datasource: ExportToDatasource;
    } | {
        oneofKind: undefined;
    };
}
/**
 * The ExportServiceGetResponse message contains the system log exporter object.
 *
 * @generated from protobuf message c1.api.systemlog.v1.ExportServiceGetResponse
 */
export interface ExportServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.systemlog.v1.Exporter exporter = 1
     */
    exporter?: Exporter;
}
/**
 * @generated from protobuf message c1.api.systemlog.v1.ExportServiceGetRequest
 */
export interface ExportServiceGetRequest {
    /**
     * @generated from protobuf field: string export_id = 1
     */
    exportId: string;
}
/**
 * @generated from protobuf message c1.api.systemlog.v1.ExportServiceUpdateRequest
 */
export interface ExportServiceUpdateRequest {
    /**
     * The Exporter object with the changes to update.
     *
     * @generated from protobuf field: c1.api.systemlog.v1.Exporter exporter = 1
     */
    exporter?: Exporter;
    /**
     * The update mask is a comma-sepparated string of fields to update. This may be something like "display_name".
     *
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.systemlog.v1.ExportServiceUpdateResponse
 */
export interface ExportServiceUpdateResponse {
    /**
     * @generated from protobuf field: c1.api.systemlog.v1.Exporter exporter = 1
     */
    exporter?: Exporter;
}
/**
 * @generated from protobuf message c1.api.systemlog.v1.ExportServiceDeleteRequest
 */
export interface ExportServiceDeleteRequest {
    /**
     * @generated from protobuf field: string export_id = 1
     */
    exportId: string;
}
/**
 * @generated from protobuf message c1.api.systemlog.v1.ExportServiceDeleteResponse
 */
export interface ExportServiceDeleteResponse {
}
/**
 * @generated from protobuf message c1.api.systemlog.v1.ExportServiceListRequest
 */
export interface ExportServiceListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.systemlog.v1.ExportServiceListResponse
 */
export interface ExportServiceListResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request
     *
     * @generated from protobuf field: repeated c1.api.systemlog.v1.Exporter list = 1
     */
    list: Exporter[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size. The server returns one page of results and the nextPageToken until all results are retreived. To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.systemlog.v1.ExportServiceListEventsRequest
 */
export interface ExportServiceListEventsRequest {
    /**
     * @generated from protobuf field: string export_id = 1
     */
    exportId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.systemlog.v1.ExportServiceListEventsResponse
 */
export interface ExportServiceListEventsResponse {
    /**
     * @generated from protobuf field: string next_page_token = 1
     */
    nextPageToken: string;
    /**
     * List contains an array of JSON OCSF events.
     *
     * @generated from protobuf field: repeated google.protobuf.Struct list = 2
     */
    list: Struct[];
}
/**
 * @generated from protobuf enum c1.api.systemlog.v1.ExportFormat
 */
export enum ExportFormat {
    /**
     * @generated from protobuf enum value: EXPORT_FORMAT_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: EXPORT_FORMAT_OCSF_JSON_ZSTD = 1;
     */
    OCSF_JSON_ZSTD = 1,
    /**
     * @generated from protobuf enum value: EXPORT_FORMAT_OCSF_JSON_GZIP = 2;
     */
    OCSF_JSON_GZIP = 2
}
/**
 * @generated from protobuf enum c1.api.systemlog.v1.ExportState
 */
export enum ExportState {
    /**
     * @generated from protobuf enum value: EXPORT_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: EXPORT_STATE_EXPORTING = 1;
     */
    EXPORTING = 1,
    /**
     * @generated from protobuf enum value: EXPORT_STATE_WAITING = 2;
     */
    WAITING = 2,
    /**
     * @generated from protobuf enum value: EXPORT_STATE_ERROR = 3;
     */
    ERROR = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class ExportsSearchServiceSearchRequest$Type extends MessageType<ExportsSearchServiceSearchRequest> {
    constructor() {
        super("c1.api.systemlog.v1.ExportsSearchServiceSearchRequest", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ExporterRef }
        ]);
    }
    create(value?: PartialMessage<ExportsSearchServiceSearchRequest>): ExportsSearchServiceSearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.displayName = "";
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<ExportsSearchServiceSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExportsSearchServiceSearchRequest): ExportsSearchServiceSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* string display_name */ 4:
                    message.displayName = reader.string();
                    break;
                case /* repeated c1.api.systemlog.v1.ExporterRef refs */ 5:
                    message.refs.push(ExporterRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExportsSearchServiceSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* string display_name = 4; */
        if (message.displayName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.displayName);
        /* repeated c1.api.systemlog.v1.ExporterRef refs = 5; */
        for (let i = 0; i < message.refs.length; i++)
            ExporterRef.internalBinaryWrite(message.refs[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.systemlog.v1.ExportsSearchServiceSearchRequest
 */
export const ExportsSearchServiceSearchRequest = new ExportsSearchServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExportsSearchServiceSearchResponse$Type extends MessageType<ExportsSearchServiceSearchResponse> {
    constructor() {
        super("c1.api.systemlog.v1.ExportsSearchServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Exporter },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ExportsSearchServiceSearchResponse>): ExportsSearchServiceSearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ExportsSearchServiceSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExportsSearchServiceSearchResponse): ExportsSearchServiceSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.systemlog.v1.Exporter list */ 1:
                    message.list.push(Exporter.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExportsSearchServiceSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.systemlog.v1.Exporter list = 1; */
        for (let i = 0; i < message.list.length; i++)
            Exporter.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.systemlog.v1.ExportsSearchServiceSearchResponse
 */
export const ExportsSearchServiceSearchResponse = new ExportsSearchServiceSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExportToDatasource$Type extends MessageType<ExportToDatasource> {
    constructor() {
        super("c1.api.systemlog.v1.ExportToDatasource", [
            { no: 1, name: "datasource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 2, name: "prefix", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "512", pattern: "^$|^[A-Za-z0-9!_\\.\\*'\\(\\)/-]*$" } } } },
            { no: 3, name: "format", kind: "enum", T: () => ["c1.api.systemlog.v1.ExportFormat", ExportFormat, "EXPORT_FORMAT_"], options: { "validate.rules": { enum: { definedOnly: true } } } }
        ]);
    }
    create(value?: PartialMessage<ExportToDatasource>): ExportToDatasource {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.datasourceId = "";
        message.prefix = "";
        message.format = 0;
        if (value !== undefined)
            reflectionMergePartial<ExportToDatasource>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExportToDatasource): ExportToDatasource {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string datasource_id */ 1:
                    message.datasourceId = reader.string();
                    break;
                case /* string prefix */ 2:
                    message.prefix = reader.string();
                    break;
                case /* c1.api.systemlog.v1.ExportFormat format */ 3:
                    message.format = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExportToDatasource, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string datasource_id = 1; */
        if (message.datasourceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.datasourceId);
        /* string prefix = 2; */
        if (message.prefix !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.prefix);
        /* c1.api.systemlog.v1.ExportFormat format = 3; */
        if (message.format !== 0)
            writer.tag(3, WireType.Varint).int32(message.format);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.systemlog.v1.ExportToDatasource
 */
export const ExportToDatasource = new ExportToDatasource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExportServiceCreateRequest$Type extends MessageType<ExportServiceCreateRequest> {
    constructor() {
        super("c1.api.systemlog.v1.ExportServiceCreateRequest", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "512" } } } },
            { no: 100, name: "datasource", kind: "message", oneof: "exportTo", T: () => ExportToDatasource }
        ]);
    }
    create(value?: PartialMessage<ExportServiceCreateRequest>): ExportServiceCreateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.displayName = "";
        message.exportTo = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<ExportServiceCreateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExportServiceCreateRequest): ExportServiceCreateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string display_name */ 1:
                    message.displayName = reader.string();
                    break;
                case /* c1.api.systemlog.v1.ExportToDatasource datasource */ 100:
                    message.exportTo = {
                        oneofKind: "datasource",
                        datasource: ExportToDatasource.internalBinaryRead(reader, reader.uint32(), options, (message.exportTo as any).datasource)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExportServiceCreateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string display_name = 1; */
        if (message.displayName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.displayName);
        /* c1.api.systemlog.v1.ExportToDatasource datasource = 100; */
        if (message.exportTo.oneofKind === "datasource")
            ExportToDatasource.internalBinaryWrite(message.exportTo.datasource, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.systemlog.v1.ExportServiceCreateRequest
 */
export const ExportServiceCreateRequest = new ExportServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExportServiceCreateResponse$Type extends MessageType<ExportServiceCreateResponse> {
    constructor() {
        super("c1.api.systemlog.v1.ExportServiceCreateResponse", [
            { no: 1, name: "exporter", kind: "message", T: () => Exporter }
        ]);
    }
    create(value?: PartialMessage<ExportServiceCreateResponse>): ExportServiceCreateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ExportServiceCreateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExportServiceCreateResponse): ExportServiceCreateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.systemlog.v1.Exporter exporter */ 1:
                    message.exporter = Exporter.internalBinaryRead(reader, reader.uint32(), options, message.exporter);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExportServiceCreateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.systemlog.v1.Exporter exporter = 1; */
        if (message.exporter)
            Exporter.internalBinaryWrite(message.exporter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.systemlog.v1.ExportServiceCreateResponse
 */
export const ExportServiceCreateResponse = new ExportServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExporterRef$Type extends MessageType<ExporterRef> {
    constructor() {
        super("c1.api.systemlog.v1.ExporterRef", [
            { no: 1, name: "export_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ExporterRef>): ExporterRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.exportId = "";
        if (value !== undefined)
            reflectionMergePartial<ExporterRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExporterRef): ExporterRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string export_id */ 1:
                    message.exportId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExporterRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string export_id = 1; */
        if (message.exportId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.exportId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.systemlog.v1.ExporterRef
 */
export const ExporterRef = new ExporterRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Exporter$Type extends MessageType<Exporter> {
    constructor() {
        super("c1.api.systemlog.v1.Exporter", [
            { no: 1, name: "export_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "512" } } } },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "state", kind: "enum", T: () => ["c1.api.systemlog.v1.ExportState", ExportState, "EXPORT_STATE_"], options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "watermark_event_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 100, name: "datasource", kind: "message", oneof: "exportTo", T: () => ExportToDatasource }
        ]);
    }
    create(value?: PartialMessage<Exporter>): Exporter {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.exportId = "";
        message.displayName = "";
        message.state = 0;
        message.watermarkEventId = "";
        message.exportTo = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<Exporter>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Exporter): Exporter {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string export_id */ 1:
                    message.exportId = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 3:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 4:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 5:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* c1.api.systemlog.v1.ExportState state */ 6:
                    message.state = reader.int32();
                    break;
                case /* string watermark_event_id */ 7:
                    message.watermarkEventId = reader.string();
                    break;
                case /* c1.api.systemlog.v1.ExportToDatasource datasource */ 100:
                    message.exportTo = {
                        oneofKind: "datasource",
                        datasource: ExportToDatasource.internalBinaryRead(reader, reader.uint32(), options, (message.exportTo as any).datasource)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Exporter, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string export_id = 1; */
        if (message.exportId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.exportId);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* google.protobuf.Timestamp created_at = 3; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 4; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 5; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.systemlog.v1.ExportState state = 6; */
        if (message.state !== 0)
            writer.tag(6, WireType.Varint).int32(message.state);
        /* string watermark_event_id = 7; */
        if (message.watermarkEventId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.watermarkEventId);
        /* c1.api.systemlog.v1.ExportToDatasource datasource = 100; */
        if (message.exportTo.oneofKind === "datasource")
            ExportToDatasource.internalBinaryWrite(message.exportTo.datasource, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.systemlog.v1.Exporter
 */
export const Exporter = new Exporter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExportServiceGetResponse$Type extends MessageType<ExportServiceGetResponse> {
    constructor() {
        super("c1.api.systemlog.v1.ExportServiceGetResponse", [
            { no: 1, name: "exporter", kind: "message", T: () => Exporter }
        ]);
    }
    create(value?: PartialMessage<ExportServiceGetResponse>): ExportServiceGetResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ExportServiceGetResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExportServiceGetResponse): ExportServiceGetResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.systemlog.v1.Exporter exporter */ 1:
                    message.exporter = Exporter.internalBinaryRead(reader, reader.uint32(), options, message.exporter);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExportServiceGetResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.systemlog.v1.Exporter exporter = 1; */
        if (message.exporter)
            Exporter.internalBinaryWrite(message.exporter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.systemlog.v1.ExportServiceGetResponse
 */
export const ExportServiceGetResponse = new ExportServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExportServiceGetRequest$Type extends MessageType<ExportServiceGetRequest> {
    constructor() {
        super("c1.api.systemlog.v1.ExportServiceGetRequest", [
            { no: 1, name: "export_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ExportServiceGetRequest>): ExportServiceGetRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.exportId = "";
        if (value !== undefined)
            reflectionMergePartial<ExportServiceGetRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExportServiceGetRequest): ExportServiceGetRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string export_id */ 1:
                    message.exportId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExportServiceGetRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string export_id = 1; */
        if (message.exportId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.exportId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.systemlog.v1.ExportServiceGetRequest
 */
export const ExportServiceGetRequest = new ExportServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExportServiceUpdateRequest$Type extends MessageType<ExportServiceUpdateRequest> {
    constructor() {
        super("c1.api.systemlog.v1.ExportServiceUpdateRequest", [
            { no: 1, name: "exporter", kind: "message", T: () => Exporter },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value?: PartialMessage<ExportServiceUpdateRequest>): ExportServiceUpdateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ExportServiceUpdateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExportServiceUpdateRequest): ExportServiceUpdateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.systemlog.v1.Exporter exporter */ 1:
                    message.exporter = Exporter.internalBinaryRead(reader, reader.uint32(), options, message.exporter);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 2:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExportServiceUpdateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.systemlog.v1.Exporter exporter = 1; */
        if (message.exporter)
            Exporter.internalBinaryWrite(message.exporter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 2; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.systemlog.v1.ExportServiceUpdateRequest
 */
export const ExportServiceUpdateRequest = new ExportServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExportServiceUpdateResponse$Type extends MessageType<ExportServiceUpdateResponse> {
    constructor() {
        super("c1.api.systemlog.v1.ExportServiceUpdateResponse", [
            { no: 1, name: "exporter", kind: "message", T: () => Exporter }
        ]);
    }
    create(value?: PartialMessage<ExportServiceUpdateResponse>): ExportServiceUpdateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ExportServiceUpdateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExportServiceUpdateResponse): ExportServiceUpdateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.systemlog.v1.Exporter exporter */ 1:
                    message.exporter = Exporter.internalBinaryRead(reader, reader.uint32(), options, message.exporter);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExportServiceUpdateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.systemlog.v1.Exporter exporter = 1; */
        if (message.exporter)
            Exporter.internalBinaryWrite(message.exporter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.systemlog.v1.ExportServiceUpdateResponse
 */
export const ExportServiceUpdateResponse = new ExportServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExportServiceDeleteRequest$Type extends MessageType<ExportServiceDeleteRequest> {
    constructor() {
        super("c1.api.systemlog.v1.ExportServiceDeleteRequest", [
            { no: 1, name: "export_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ExportServiceDeleteRequest>): ExportServiceDeleteRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.exportId = "";
        if (value !== undefined)
            reflectionMergePartial<ExportServiceDeleteRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExportServiceDeleteRequest): ExportServiceDeleteRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string export_id */ 1:
                    message.exportId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExportServiceDeleteRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string export_id = 1; */
        if (message.exportId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.exportId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.systemlog.v1.ExportServiceDeleteRequest
 */
export const ExportServiceDeleteRequest = new ExportServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExportServiceDeleteResponse$Type extends MessageType<ExportServiceDeleteResponse> {
    constructor() {
        super("c1.api.systemlog.v1.ExportServiceDeleteResponse", []);
    }
    create(value?: PartialMessage<ExportServiceDeleteResponse>): ExportServiceDeleteResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ExportServiceDeleteResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExportServiceDeleteResponse): ExportServiceDeleteResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExportServiceDeleteResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.systemlog.v1.ExportServiceDeleteResponse
 */
export const ExportServiceDeleteResponse = new ExportServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExportServiceListRequest$Type extends MessageType<ExportServiceListRequest> {
    constructor() {
        super("c1.api.systemlog.v1.ExportServiceListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 512, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<ExportServiceListRequest>): ExportServiceListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ExportServiceListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExportServiceListRequest): ExportServiceListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExportServiceListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.systemlog.v1.ExportServiceListRequest
 */
export const ExportServiceListRequest = new ExportServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExportServiceListResponse$Type extends MessageType<ExportServiceListResponse> {
    constructor() {
        super("c1.api.systemlog.v1.ExportServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Exporter },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ExportServiceListResponse>): ExportServiceListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ExportServiceListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExportServiceListResponse): ExportServiceListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.systemlog.v1.Exporter list */ 1:
                    message.list.push(Exporter.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExportServiceListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.systemlog.v1.Exporter list = 1; */
        for (let i = 0; i < message.list.length; i++)
            Exporter.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.systemlog.v1.ExportServiceListResponse
 */
export const ExportServiceListResponse = new ExportServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExportServiceListEventsRequest$Type extends MessageType<ExportServiceListEventsRequest> {
    constructor() {
        super("c1.api.systemlog.v1.ExportServiceListEventsRequest", [
            { no: 1, name: "export_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 512, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<ExportServiceListEventsRequest>): ExportServiceListEventsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.exportId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ExportServiceListEventsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExportServiceListEventsRequest): ExportServiceListEventsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string export_id */ 1:
                    message.exportId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExportServiceListEventsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string export_id = 1; */
        if (message.exportId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.exportId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.systemlog.v1.ExportServiceListEventsRequest
 */
export const ExportServiceListEventsRequest = new ExportServiceListEventsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExportServiceListEventsResponse$Type extends MessageType<ExportServiceListEventsResponse> {
    constructor() {
        super("c1.api.systemlog.v1.ExportServiceListEventsResponse", [
            { no: 1, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Struct }
        ]);
    }
    create(value?: PartialMessage<ExportServiceListEventsResponse>): ExportServiceListEventsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.nextPageToken = "";
        message.list = [];
        if (value !== undefined)
            reflectionMergePartial<ExportServiceListEventsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExportServiceListEventsResponse): ExportServiceListEventsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string next_page_token */ 1:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Struct list */ 2:
                    message.list.push(Struct.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExportServiceListEventsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string next_page_token = 1; */
        if (message.nextPageToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Struct list = 2; */
        for (let i = 0; i < message.list.length; i++)
            Struct.internalBinaryWrite(message.list[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.systemlog.v1.ExportServiceListEventsResponse
 */
export const ExportServiceListEventsResponse = new ExportServiceListEventsResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.systemlog.v1.ExportService
 */
export const ExportService = new ServiceType("c1.api.systemlog.v1.ExportService", [
    { name: "Create", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/systemlog/exports", group: "System Log Exporter" }] }, "authz.method": { role: "EDITOR" } }, I: ExportServiceCreateRequest, O: ExportServiceCreateResponse },
    { name: "Get", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/systemlog/exports/{export_id}", group: "System Log Exporter" }] }, "authz.method": { role: "VIEWER" } }, I: ExportServiceGetRequest, O: ExportServiceGetResponse },
    { name: "Update", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/systemlog/exports/{exporter.export_id}", group: "System Log Exporter" }] }, "authz.method": { role: "EDITOR" } }, I: ExportServiceUpdateRequest, O: ExportServiceUpdateResponse },
    { name: "Delete", options: { "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/systemlog/exports/{export_id}", group: "System Log Exporter" }] }, "authz.method": { role: "EDITOR" } }, I: ExportServiceDeleteRequest, O: ExportServiceDeleteResponse },
    { name: "List", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/systemlog/exports", query: { page_size: "page_size", page_token: "page_token" }, group: "System Log Exporter" }] }, "authz.method": { role: "VIEWER" } }, I: ExportServiceListRequest, O: ExportServiceListResponse },
    { name: "ListEvents", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/systemlog/exports/{export_id}/events", group: "System Log Exporter" }] }, "authz.method": { role: "VIEWER" } }, I: ExportServiceListEventsRequest, O: ExportServiceListEventsResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.systemlog.v1.ExportsSearchService
 */
export const ExportsSearchService = new ServiceType("c1.api.systemlog.v1.ExportsSearchService", [
    { name: "Search", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/search/systemlog/exports", group: "System Log Exporter" }] }, "authz.method": { role: "VIEWER" } }, I: ExportsSearchServiceSearchRequest, O: ExportsSearchServiceSearchResponse }
]);
